export const project = [
  {
    title: "TuneScape",
    description:
      "TuneScape is a music streaming platform allowing users to create lobbies with unique codes for social listening experiences",
    thumbnail:
      "https://res.cloudinary.com/drtjsnrcp/image/upload/v1711601347/FileUploadApp/au32ds4no3idojowa3f9.png",
    link: "https://tunescape.netlify.app/",
    gitHub: "https://github.com/akashlitoriya/TuneScape",
    skills: ["Socket.io", "NodeJS", "ExpressJS", "ReactJS", "MongoDB", "Redux"],
  },
  {
    title: "StudyNotion",
    description:
      "StudyNotion is a robust LMS platform, powered by the MERN stack, offering an intuitive and efficient e-learning experience.",
    thumbnail:
      "https://res.cloudinary.com/dvu9lo8mq/image/upload/v1698955542/Portfolio/xldpel4crv3ylkl3xumo.png",
    link: "https://study-notion-akash-litoriya.vercel.app/",
    gitHub: "https://github.com/akashlitoriya/StudyNotion",
    skills: [
      "ReactJS",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
      "Redux",
      "TailwindCSS",
    ],
  },
  {
    title: "FoodVilla",
    description:
      "A sleek ReactJS and TailwindCSS powered front-end app for seamless food ordering, offering a delightful user experience.",
    thumbnail:
      "https://res.cloudinary.com/dvu9lo8mq/image/upload/v1698955465/Portfolio/ijpkhztkvz2lbpi5gxte.png",
    link: "https://foodvillaakash.netlify.app/",
    gitHub: "https://github.com/akashlitoriya/NamasteReact",
    skills: ["ReactJS", "TailwindCSS", "Redux", "Babel"],
  },
  {
    title: "Utero",
    description:
      "A sleek, responsive static website for online shopping, meticulously crafted with HTML, CSS, and JavaScript for a seamless user experience.",
    thumbnail:
      "https://res.cloudinary.com/dvu9lo8mq/image/upload/v1698955635/Portfolio/iqzrs3fc6kdomhpjq6yp.png",
    link: "https://akashlitoriya.github.io/ShoppingWebsite.github.io/",
    gitHub: "https://github.com/akashlitoriya/ShoppingWebsite.github.io",
    skills: ["HTML", "CSS", "JavaScript"],
  },
];
